import {
    ANALYTICS_SET_STOP_INITIATED_BY,
    ANALYTICS_SET_USER_KEY,
    ANALYTICS_SET_SESSION_ID,
    ANALYTICS_SET_ATTRIBUTES,
    ANALYTICS_SET_PAGE_SESSION_ID,
} from './analyticActions'

import { Map } from 'immutable'

const INITIAL_STATE = Map({
    stopInitiatedBy: null,
    userkey: null,
    sessionId: null,
    pageSessionId: null, // pageSessionId is used with regards to super-content (when embedded in an iFrame)
    analyticAttributes: null,
    sessionStartedAt: new Date(),
    analyticsInteractionCount: 0,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ANALYTICS_SET_PAGE_SESSION_ID:
            return state.set('pageSessionId', action.pageSessionId)
        case ANALYTICS_SET_ATTRIBUTES:
            return state.set('analyticAttributes', action.attributes)
        case ANALYTICS_SET_STOP_INITIATED_BY:
            return state.set('stopInitiatedBy', action.initiatedBy)
        case ANALYTICS_SET_USER_KEY:
            return state.set('userkey', action.userkey)
        case ANALYTICS_SET_SESSION_ID:
            return state.set('sessionId', action.sessionId)
        default:
            return state
    }
}
